// The account pieces (header controls, account page, bug report page,
// settings dialog), built by kast-common's account kit around this app's
// session, sign-in and admin switch. The pages around them are in this folder
// and bug-report/.

import { Link, useLocation } from "react-router-dom";
import { hasGroup, redirectToSignIn } from "@jkast90/kast-common/auth";
import { createAccountKit } from "@jkast90/kast-common/account";
import { LegalLinks } from "@jkast90/kast-common/legal/react";
import { buttonClass } from "@jkast90/kast-common/ui";
import { adminMode, session, signOut } from "../auth/session";
import legalStyles from "../legal/pages/LegalPage.module.css";
import { themeStore } from "../common/theme";
import { deploymentConfig } from "../common/deployment-config";

// kui-input is ui.css's text field class, for the shared form's own fields.
const PAGE_CLASSES = {
  button: buttonClass(),
  input: `kui-input ${legalStyles.formInput}`,
  section: legalStyles.formSection,
};

export const { AccountControls, AccountPage, BugReportPage, AppSettings } = createAccountKit({
  session,
  signIn: () => redirectToSignIn(),
  signOut: () => void signOut(),
  themeStore,
  admin: adminMode,
  apiUrl: () => deploymentConfig.get("apiUrl"),
  // Reports land in this app's own Bug Reports tab; admins also see the logs that ride along.
  useLocationState: () => useLocation().state,
  bugReport: { app: "kast-dev-admin", showLogs: (state) => hasGroup(state, "admin"), classNames: PAGE_CLASSES },
  settings: {
    adminDescription: "Show the Admin link in the header, on this device",
    legal: <LegalLinks renderLink={(link) => <Link to={new URL(link.url).pathname}>{link.label}</Link>} />,
  },
});
